module.exports = __webpack_public_path__ + "static/media/seafood_shellfish.f4a59d30.png";